export default __webpack_public_path__ + "static/media/Firefox.2ba9ac82.svg";